export default __webpack_public_path__ + "static/media/img-3.bf3a7e49.png";